<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>
        <span class="headline">B/L確認完了送信</span>
      </v-card-title>
      <div :key="employee.email" v-for="employee in employees">
        <div class="name">
          氏名：{{ employee.code }}:{{ employee.fullName }}
        </div>
        <div class="email">Email：{{ employee.email }}</div>
      </div>
      <v-card-actions class="justify-center">
        <v-btn @click="send()">Mail送信</v-btn>
        <v-btn @click="show = false">戻る</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['employees'],
  data() {
    return {
      selecetd: '',
      show: false,
      id: '',
      errors: {
        EMPTY_CONTAINER_NO: 'INV P/L情報が不整備です、ご確認お願いします。',
      },
    }
  },
  methods: {
    send() {
      this.$http
        .put(`shipping-advices/${this.id}/bl-send`)
        .then(() => {
          this.$message('', 'BL確認完了メールが送信成功しました')
          this.$emit('refresh')
          this.show = false
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    close() {
      this.$emit('closeEvent', false)
    },
    popup(id) {
      this.show = true
      this.id = id
    },
  },
}
</script>

<style scoped>
.name {
  /* border: 2px solid #000; */
  display: inline-block;
  width: 400px;
  margin-left: 60px;
  margin-top: 20px;
  padding: 5px 5px;
}
.email {
  /* border: 2px solid #000; */
  display: inline-block;
  margin-left: 20px;
  margin-top: 20px;
  padding: 5px 5px;
}
</style>
